import React from 'react';

function scoreColor(score) {
  if (score >= 80) return 'var(--green)';
  if (score >= 60) return 'var(--cyan)';
  if (score >= 40) return 'var(--yellow)';
  if (score >= 20) return 'var(--orange)';
  return 'var(--red)';
}

function scoreLabel(score) {
  if (score >= 80) return 'מצוין';
  if (score >= 60) return 'טוב';
  if (score >= 40) return 'בינוני';
  if (score >= 20) return 'חלש';
  return 'קריטי';
}

export default function GeoScoreCard({ score, size = 120, label, showLabel = true }) {
  const color = scoreColor(score);
  const radius = (size - 12) / 2;
  const circumference = 2 * Math.PI * radius;
  const progress = ((score || 0) / 100) * circumference;
  const center = size / 2;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '6px' }}>
      <svg width={size} height={size} style={{ transform: 'rotate(-90deg)' }}>
        <circle cx={center} cy={center} r={radius} fill="none" stroke="var(--border)" strokeWidth="6" />
        <circle cx={center} cy={center} r={radius} fill="none" stroke={color} strokeWidth="6"
          strokeLinecap="round" strokeDasharray={circumference}
          strokeDashoffset={circumference - progress}
          style={{ transition: 'stroke-dashoffset 0.8s ease-out' }} />
        <text x={center} y={center} fill={color} fontSize={size * 0.28} fontWeight="800"
          fontFamily="var(--mono)" textAnchor="middle" dominantBaseline="central"
          style={{ transform: 'rotate(90deg)', transformOrigin: 'center' }}>
          {score ?? '-'}
        </text>
      </svg>
      {showLabel && (
        <div style={{ textAlign: 'center' }}>
          {label && <div style={{ fontSize: '12px', color: 'var(--text-muted)', marginBottom: '2px' }}>{label}</div>}
          <div style={{ fontSize: '13px', fontWeight: 600, color }}>{scoreLabel(score)}</div>
        </div>
      )}
    </div>
  );
}

export { scoreColor, scoreLabel };
